import { create } from "zustand";
import { persist } from "zustand/middleware";

interface RecentlyViewedStore {
	products: string[];
	// eslint-disable-next-line no-unused-vars
	addProduct: (sku: string) => void;
}

export const useRecentlyViewed = create(
	persist<RecentlyViewedStore>(
		(set) => ({
			products: [],
			addProduct: (sku: string) =>
				set((state) => ({
					products: [sku, ...state.products.filter((p) => p !== sku)],
				})),
		}),
		{
			name: "recently-viewed",
			version: 1,
		},
	),
);
